module.exports = __webpack_public_path__ + "img/about.a34883eb.svg";